import React from 'react';
import {StyledAvailabilityRow} from "@app/availabilityPage/panes/availability.style";
import {Proposal} from "@models/calendar";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {formatDurationHuman} from "@services/calendar/availability.service";

type ProposalEventProps = {
    proposal: Proposal,
    onClick: () => void,
}

const ProposalEvent: React.FC<ProposalEventProps> = ({proposal, onClick}: ProposalEventProps) => {
    const {t} = useTranslation();

    const duration = moment(proposal.attributes.originalEndTime).diff(moment(proposal.attributes.originalStartTime), 'minutes');

    return (
        <>
            <StyledAvailabilityRow type="proposal" onClick={() => onClick()}>
                <div className="time">{moment(proposal.startTime).format('HH:mm')} - {moment(proposal.endTime).format('HH:mm')}</div>
                <div className="content">
                    <div className="info">
                        <span>{t('availability.proposal.title')} - {formatDurationHuman(duration)}</span>
                    </div>
                </div>
            </StyledAvailabilityRow>
        </>
    );
};

export default ProposalEvent;
